"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Card = _interopRequireDefault(require("@mui/material/Card"));
var _CardStyles = require("./CardStyles");
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const merge = require("deepmerge"),
  CardButton = props => {
    const {
        customClassNames,
        path,
        label,
        onClick,
        buttonTestId,
        variant = "primary",
        url
      } = props,
      buttonClasses = (0, _classnames.default)({
        "RTECard__button": true,
        [`${customClassNames}`]: (0, _string.isStringOfLength)(customClassNames)
      });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _string.isStringOfLength)(label) && (0, _string.isStringOfLength)(path) && /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: buttonClasses,
      component: _reactRouterDom.Link,
      "data-testid": buttonTestId,
      onClick: onClick,
      to: path,
      variant: variant
    }, label), (0, _string.isStringOfLength)(label) && (0, _string.isStringOfLength)(url) && !(0, _string.isStringOfLength)(path) && /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: buttonClasses,
      component: "a",
      "data-testid": buttonTestId,
      onClick: onClick,
      href: url,
      target: "_blank",
      variant: variant
    }, label));
  };

/**
 * RTE Card Details
 *
 * @visibleName RTE (formerly Rich Text Editor) Card
 * @author Tanner Williams
*/
const RTECard = props => {
  const {
      button,
      customContainerSx = {},
      customTheme = {},
      fragmentId,
      variant,
      children,
      testId
    } = props,
    theme = merge((0, _styles.useTheme)(), customTheme),
    containerSx = merge((0, _CardStyles.DefaultRTECardSx)(theme), customContainerSx);
  return /*#__PURE__*/_react.default.createElement(_Card.default, {
    "data-testid": testId,
    variant: variant,
    sx: containerSx
  }, fragmentId && /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: fragmentId
  }), children, button?.label && /*#__PURE__*/_react.default.createElement(CardButton, button));
};

// Define propTypes;
RTECard.propTypes = {
  /** Object describing interior button properties */
  button: _propTypes.default.shape({
    /** Button label */
    label: _propTypes.default.string,
    /** Internal button path, if using React Router location */
    path: _propTypes.default.string,
    /** External URL, if there is no path */
    url: _propTypes.default.string,
    /** Button variant */
    variant: _propTypes.default.string
  }),
  /** Child content of card, appears after content fragment */
  children: _propTypes.default.any,
  /** Custom style override object (Default Value: {}) */
  customContainerSx: _propTypes.default.object,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** ID of content fragment */
  fragmentId: _propTypes.default.string,
  /** Card variant */
  variant: _propTypes.default.string,
  /** @ignore */
  testId: _propTypes.default.string
};
CardButton.propTypes = {
  buttonTestId: _propTypes.default.string,
  customClassNames: _propTypes.default.string,
  label: _propTypes.default.string,
  onClick: _propTypes.default.func,
  path: _propTypes.default.string,
  variant: _propTypes.default.string,
  url: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = RTECard;